<template>
  <div>
    <validation-provider ref="provider" :rules="{required: isVisible(field.identifier)}" v-slot="{ errors, validated, valid }" mode="passive" slim>
      <slot :input="handleInput" :error="errors[0]" :validated="validated" :valid="valid" />
    </validation-provider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PreliminaryValidator",
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: null,
    }
  },
  computed: {
    ...mapGetters({
      isVisible: "preliminaryAssessment/isVisible",
    }),
  },
  methods: {
    handleInput(event) {
      this.$refs.provider.validate(event);
    }
  },
  mounted() {
    this.value =
    this.$store.getters[
      this.mortgage
        ? "mortgagePreliminaryAssessment/answer"
        : "preliminaryAssessment/answer"
    ](this.field.identifier) || null;
    this.$refs.provider.validate(this.value);
  }
}
</script>